// Section13.jsx - Professional Corporate Style
import React, { useEffect, useRef, useState } from 'react';

const useReveal = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
};

const Section17 = () => {
  const expectations = [
    "Free project consultation",
    "Mobile app strategy recommendations",
    "Technology stack guidance",
    "Transparent project planning",
    "Scalable development solutions",
    "Ongoing maintenance and support"
  ];

  const [ref, visible] = useReveal();

  return (
    <section id="contact" className="bg-[#f8f9fa] py-15 md:py-20">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div
          ref={ref}
          className={`relative bg-white rounded-3xl shadow-xl border border-gray-100 p-10 md:p-16 overflow-hidden transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="pointer-events-none absolute -top-24 -right-24 w-64 h-64 bg-[#cd2122]/10 rounded-full blur-3xl" />

          <span className="relative text-[#cd2122] text-xs font-semibold uppercase tracking-widest">Get Started</span>
          <h2 className="relative text-[32px] md:text-[38px] font-extrabold text-[#1a1a1a] mt-3 mb-6 leading-tight">
            Let's Discuss Your Mobile App Project
          </h2>

          <p className="relative text-[#535353] text-[16px] max-w-2xl mx-auto mb-3">
            Whether you're building a startup MVP, modernizing an existing application, or improving internal operations, Mean3 can help turn your vision into a successful mobile solution.
          </p>
          <p className="relative text-[#535353] text-[16px] max-w-2xl mx-auto mb-10">
            Our team works closely with businesses to design, develop, and launch mobile applications that deliver measurable results and long-term value.
          </p>

          <div className="relative inline-block text-left mb-12">
            <h3 className="font-semibold text-[#1a1a1a] mb-5 text-center">What You Can Expect</h3>
            <ul className="grid sm:grid-cols-2 gap-x-10 gap-y-3 text-[16px] text-[#535353]">
              {expectations.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <span className="w-5 h-5 flex-shrink-0 rounded-full bg-[#cd2122]/10 text-[#cd2122] text-xs flex items-center justify-center">✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <a
            href="/contact-mean3"
            className="relative inline-flex items-center gap-2 bg-[#cd2122] hover:bg-[#a81c1e] text-white px-12 py-5 rounded-full text-[12px] md:text-[16px] font-semibold transition-all duration-300 shadow-lg shadow-[#cd2122]/20 hover:shadow-2xl hover:-translate-y-0.5"
          >
            Get Free Consultation Today
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Section17;